/*
 * Slide out
 *
 * runs the functionality of functions inside the slideout.
 * The actual opening and closing of the slide-out is handled in hamburger.js
 */

const menuItem = '.js-menu-item';
const activeMenuClass = 'm-slide-out__nav-menu--active';

export function slideOut() {
    // add for active on hover
    $(menuItem).hover(
        function () {
            $(menuItem).removeClass(activeMenuClass);
            $(this).addClass(activeMenuClass);
        },
        () => {
            $(menuItem).removeClass(activeMenuClass);
        },
    );
}
